export default {"src":"/_next/static/media/star.0ecfd8a7.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};